import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=db52f38c&scoped=true"
import script from "./bottom.vue?vue&type=script&lang=js"
export * from "./bottom.vue?vue&type=script&lang=js"
import style0 from "./bottom.vue?vue&type=style&index=0&id=db52f38c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db52f38c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db52f38c')) {
      api.createRecord('db52f38c', component.options)
    } else {
      api.reload('db52f38c', component.options)
    }
    module.hot.accept("./bottom.vue?vue&type=template&id=db52f38c&scoped=true", function () {
      api.rerender('db52f38c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/components/bottom.vue"
export default component.exports